import React from 'react';
import { ImageSecurity } from '@common/components/ImageSecurity';
import { ImageBackground, ImageBackgroundProps } from 'react-native';

export const ImageBackgroundSecurity: React.FC<ImageBackgroundProps> = (
  props
) => {
  const uri =
    typeof props.source === 'object' &&
    !Array.isArray(props.source) &&
    props.source?.uri
      ? props.source?.uri
      : null;
  if (uri) {
    return (
      <ImageSecurity src={uri}>
        {({ imageUrl }) => (
          <ImageBackground
            {...props}
            source={{
              uri: imageUrl,
            }}
          ></ImageBackground>
        )}
      </ImageSecurity>
    );
  }
  return <ImageBackground {...props} />;
};
